import { createContext, type RefObject } from 'react';

export const TreeMapOverlayRefContext = createContext<
  RefObject<HTMLElement | null> | undefined
>(undefined);
